import React from "react";
import styles from "./home.module.css";
import NavBar from "../../components/NavBar/NavBar";
import HeroSection from "../../components/heroSection/heroSection";
import Card from "../../components/cardHero/cardHero";
import bankIcon from "../../assets/images/bank-line.svg";
import chargingIcon from "../../assets/images/charging-pile-line.svg";
import navigatingIcon from "../../assets/images/Vector.svg";
import Footer from "../../components/footer/footer";
import Divisions from "../../components/divisions/division";
const home = () => {
  return (
    <div>
      <NavBar />
      <div className={styles.heroSectionContainer}>
        <HeroSection />
        <div className={styles.cardsContainer}>
          <Card
            icon={bankIcon}
            header="Foster Financial Security"
            paragraph="Stewarding capital with integrity and conviction to deliver outstanding performance for institutional and individual investors alike. Learn more about our commitment to building strong businesses and securing brighter futures."
          />
          <Card
            icon={chargingIcon}
            header="Fuel Your Business"
            paragraph="Unlock tailored solutions for business growth and expansion with our comprehensive suite of financial services. Explore how our dedicated team propels businesses to thrive in a dynamic financial landscape."
          />
          <Card
            icon={navigatingIcon}
            header="Navigating Sustainability"
            paragraph="Embrace a forward-thinking approach to navigate the fast-paced and dynamic world of finance. With a focus on long-term success, we provide insight to build generational prosperity in an ever-evolving economy."
          />
        </div>
      </div>
      <div className={styles.growingContainer}>
        <h2 className={styles.header}>About the growing investment bank</h2>
        <p className={styles.paragraph}>
          At CFH, we are a leading provider of financial solutions, specializing
          in corporate finance, investment banking, asset management, brokerage,
          private equity, equity research, and non-bank financial intermediary
          services. Catering to a diverse clientele, we redefine financial
          excellence through innovation and expertise. With a commitment to
          optimizing returns and managing risk, we guide investors towards their
          objectives with responsability and foresight.
        </p>
      </div>
      <Divisions />
      <Footer />
    </div>
  );
};

export default home;
